export default {

  light: {
    '--border-radius': '.625rem',
    '--color-background': '#fff',
    '--color-text': '#000',
    '--color-contrast': '#000',
  },

  dark: {
    '--border-radius': '.625rem',
    '--color-background': '#333',
    '--color-text': '#fff',
    '--color-contrast': '#000',
  },

}